import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Box, makeStyles } from '@material-ui/core';
import { statuses } from 'constants/booking';
import CottageInfo from './CottageInfo';
import Info from './Info';
import OverlapWarning from './OverlapWarning';

const styles = makeStyles((theme) => ({
  smGridLeft: {
    [theme.breakpoints.down('xs')]: {
      order: 1,
    },
  },
  smGridRight: {
    [theme.breakpoints.down('xs')]: {
      order: 2,
    },
  },
}));

const BookingPreview = (props) => {
  const { booking, cottage, overlap, overlapAccepted, setOverlapAccepted, setEditMode } = props;
  const classes = styles();

  if (!booking) {
    return null;
  }

  const showWarning = !!overlap && !!overlap.length;

  return (
    <Box p={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5" align="center">
            {cottage.title_sv}
          </Typography>
        </Grid>
        {showWarning && (
          <Grid item xs={12}>
            <OverlapWarning
              overlap={overlap}
              onAccept={overlapAccepted ? undefined : () => setOverlapAccepted(true)}
              onCancel={overlapAccepted ? undefined : setEditMode}
            />
          </Grid>
        )}
        {(!showWarning || overlapAccepted) && (
          <>
            <Grid item xs={12} sm={6} className={classes.smGridRight}>
              <Info {...props} isHost preview />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.smGridLeft}>
              <CottageInfo id={cottage.id} cottagePic={cottage.cottagePic} taller />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

BookingPreview.propTypes = {
  overlap: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      conversation_id: PropTypes.number,
      check_in: PropTypes.string,
      check_out: PropTypes.string,
    }),
  ),
  booking: PropTypes.shape({
    Guest: PropTypes.shape({}).isRequired,
    Host: PropTypes.shape({}).isRequired,
    additional_information: PropTypes.string,
    booking_expiration_date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    cancellationPolicy: PropTypes.shape({}),
    check_in: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    check_out: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    cleaning_policy: PropTypes.string.isRequired,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }),
    isHost: PropTypes.bool,
    number_of_guests: PropTypes.number.isRequired,
    status: PropTypes.oneOf(Object.values(statuses)),
    total_price: PropTypes.number.isRequired,
  }),
  cottage: PropTypes.shape({
    title_sv: PropTypes.string.isRequired,
    cottagePic: PropTypes.string,
    id: PropTypes.number.isRequired,
  }).isRequired,
  cancellationPolicy: PropTypes.shape({}),
  setEditMode: PropTypes.func.isRequired,
  overlapAccepted: PropTypes.bool.isRequired,
  setOverlapAccepted: PropTypes.func.isRequired,
};

export default BookingPreview;
